import { React, useEffect, useRef, useState } from "react";
import party from "party-js";
import "./FoldedPopup.scss";

function FoldedPopup(props) {
  const isEnabled = props.enabled;
  const setIsEnabled = props.setEnabled;
  const confetti = useRef(null);

  useEffect(() => {
    if (props.enabled && props.confetti && confetti.current) {
      party.confetti(confetti.current);
    }
  }, [props.enabled]);

  return (
    isEnabled && (
      <div
        className={
          "folded-popup-container-div fader" +
          (props.className ? " " + props.className : "") +
          (props.noImage ? " no-image" : "")
        }
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          position: "fixed",
        }}
        ref={confetti}
        /*onClick={() => {
          if (props.closeButton) {
            setIsEnabled(false);
          }
        }}*/
      >
        <div
          className="folded-popup-left"
          style={props.noImage ? { borderRadius: "15px", height: "auto"} : {}}
        >
          {props.closeButton && (
            <p
              className="close"
              onClick={() => {
                setIsEnabled(false);
              }}
            >
              X
            </p>
          )}
          <div className="folded-popup-children">{props.children}</div>
        </div>
        {!props.noImage && (
          <div className="folded-popup-right">
            {props.closeButton && (
              <p
                className="close"
                onClick={() => {
                  setIsEnabled(false);
                }}
              >
                X
              </p>
            )}
            {!props.rightSideContents ? (
              <img
                src={
                  props.image_url ??
                  "https://quizzynow.com/uploads/mockups/mockup1.png"
                }
                alt="quizzy mockup"
              ></img>
            ) : (
              props.rightSideContents
            )}
          </div>
        )}
      </div>
    )
  );
}

export default FoldedPopup;
